var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn_offerwall",on:{"click":_vm.onClick}},[_c('span',{staticClass:"ico_offerwall"},[_vm._v("맨 위로 이동")])])}
var staticRenderFns = []

export { render, staticRenderFns }